import { INFORMACAO_MODALIDADES } from '../../constants'
import { isArray, isEmptyObject } from './helpers'

export const getInformacoesModalidadePorAssinatura = modalidade => {
  const filterInformacaoModalidade = INFORMACAO_MODALIDADES.find( info => {
    if ( modalidade ) {
      return Object.values( info ).includes( modalidade )
    }

    return {}
  } )

  return filterInformacaoModalidade
}

export const getFreteDaModalidade = ( frete, idModalidade ) => {
  if ( !isArray( frete ) || !idModalidade ) {
    return null
  }

  const freteDaModalidade = frete.find( valorFrete => {
    if ( valorFrete.idModalidade ) {
      return valorFrete.idModalidade === idModalidade
    }

    return false
  } )

  return freteDaModalidade || null
}

export const getModalidadeDeAssinatura = assinaturas => {
  if ( assinaturas && assinaturas.length ) {
    return assinaturas.map( assinatura => assinatura.modalidade )
  }

  return null
}

export const getModalidadePelaURL = ( modalidadeURL, modalidadeAssinatura ) => {
  if ( modalidadeAssinatura && modalidadeAssinatura.length ) {
    const infoModalidade = getInformacoesModalidadePorAssinatura( modalidadeURL )
    if ( !isEmptyObject( infoModalidade ) ) {
      const modalidade = modalidadeAssinatura.includes( infoModalidade.visualizacao )
      if ( modalidade ) {
        return modalidadeURL
      }
    }

    return null
  }
}

export const getMetodoPagamentoModalidadePelaURL = ( assinaturas, modalidade ) => {
  const infosModalidade = getInformacoesModalidadePorAssinatura( modalidade )
  if ( assinaturas && assinaturas.length && modalidade ) {
    const assinaturaModalidade = assinaturas.find( assinatura => {
      return assinatura.modalidade && assinatura.modalidade.toLowerCase() === infosModalidade.visualizacao.toLowerCase()
    } )

    return assinaturaModalidade.metodoPagamento
  }

  return null
}

export const getAssinaturaDoAssociadoPorModalidade = ( assinaturas, modalidade ) => {
  const infosModalidade = getInformacoesModalidadePorAssinatura( modalidade )
  if ( assinaturas && assinaturas.length && modalidade ) {
    const assinaturaModalidade = assinaturas.find( assinatura => {
      return assinatura.modalidade && assinatura.modalidade.toLowerCase() === infosModalidade.visualizacao.toLowerCase()
    } )

    return assinaturaModalidade
  }

  return null
}
